import { render, staticRenderFns } from "./link-preview.vue?vue&type=template&id=4a125c20&scoped=true&"
import script from "./link-preview.vue?vue&type=script&lang=js&"
export * from "./link-preview.vue?vue&type=script&lang=js&"
import style0 from "./link-preview.vue?vue&type=style&index=0&id=4a125c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a125c20",
  null
  
)

export default component.exports